import React from 'react';
import { Icon } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellSteps.scss';

const STEPS = [
  { key: 'step1', icon: 'search' },
  { key: 'step2', icon: 'camera' },
  { key: 'step3', icon: 'messages' },
] as const;

const SellSteps = () => {
  const { t } = useI18nContext();

  return (
    <section className={`PageContent-card PageContent-offset ${Classes.root}`}>
      <div className={Classes.heading}>
        <h2 className={Classes.title}>{t('sell.page.steps.title')}</h2>
      </div>
      <ol className={Classes.steps}>
        {STEPS.map(({ key, icon }, index) => (
          <li key={key} className={Classes.step}>
            <div className={Classes.iconCircle}>
              <Icon name={icon} color="action" />
            </div>
            <h3 className={Classes.stepTitle}>{`${index + 1}. ${t(`sell.page.steps.${key}.title`)}`}</h3>
            <p className={Classes.stepBody}>{t(`sell.page.steps.${key}.body`)}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default SellSteps;
